// extracted by mini-css-extract-plugin
export default {"iconButton":"---------packages-corgi-x-src-components-IconButton-IconButton-module__iconButton"};